import { render, staticRenderFns } from "./CreateMenu.vue?vue&type=template&id=0264462f&scoped=true"
import script from "./CreateMenu.vue?vue&type=script&lang=js"
export * from "./CreateMenu.vue?vue&type=script&lang=js"
import style0 from "./CreateMenu.vue?vue&type=style&index=0&id=0264462f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0264462f",
  null
  
)

export default component.exports